export default {
  config: {
    app_enabled: false,
    access_type: 3,
    name: null
  }
}
